export const PHONE_NUMBER_MASK = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const TABLE_CELL_CLASSES = 'px-6 py-4 text-wrap whitespace-nowrap text-sm text-gray-800';
